import { PLAYER_WAS_TRACK_PLAYED } from '@/store/player/player.enums';

export default {
  [PLAYER_WAS_TRACK_PLAYED]: ({ trackHistory }) => (trackId) => trackHistory.includes(trackId),
};
